{
  "info": "Informace",
  "negative": "Chyba",
  "positive": "Úspěch"
}
